// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "lazy-survey" + "." + "59d7f77d" + ".chunk.css";
};